import React, {Component} from 'react';
import PropTypes from 'prop-types';
import './PlanItemDragListItem.css';
import TouchComponent from "../../Etc/TouchComponent";

export default class PlanItemDragListItem extends Component {
    handleDragStart(e) {
        e.dataTransfer.effectAllowed = "copyMove";
        e.dataTransfer.setData("text/plain", JSON.stringify(this.props.task));

        this.props.onClick(false);
    }

    handleClick(isDoubleClick) {
        this.props.onClick(true, isDoubleClick);
    }

    render() {
        let classNames = ["PlanItemDragListItem"];

        if (this.props.selected) {
            classNames.push("PlanItemDragListItem--selected");
        }

        return (
            <TouchComponent className={classNames.join(' ')} draggable={true} onDragStart={this.handleDragStart.bind(this)}
                onClick={this.handleClick.bind(this, false)} onDoubleClick={this.handleClick.bind(this, true)}
                onTap={this.handleClick.bind(this, true)}
            >
                <span>{this.props.task.name}</span>
            </TouchComponent>
        );
    }
}

PlanItemDragListItem.propTypes = {
    task: PropTypes.object,
    onClick: PropTypes.func.isRequired,
    selected: PropTypes.bool
};



// WEBPACK FOOTER //
// ./src/Portal/Planner/PlanItemDragListItem.js